export default __webpack_public_path__ + "static/media/lihat.58f415bb.svg";